import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AttToken from '../../../helpers/attToken';
import ServiceTypes from '../../../service/ServiceTypes';
import { toast } from 'react-toastify';
import queryClient from '../../../service/query';
import { AxiosError } from 'axios';
import { trackEventMatomo } from '../../../helpers/matomo';
import { Card, TextField } from '@mui/material';
import { service } from '../ServicesManagement';
import HeaderModal from '../../HeaderModal/HeaderModal';
import FooterModal from '../../FooterModal/FooterModal';
import QueryFn from '../../../helpers/QueryFn';

const serviceType = new ServiceTypes();
const queryFn = new QueryFn();

export default function ModalServiceType({
  open,
  setOpen,
  typeData,
  setTypeData,
}:
  {
    open: Boolean,
    setOpen: Function,
    typeData: service,
    setTypeData: Function,
  }) {

  const { t } = useTranslation('translation');

  const escape = useCallback((e: any): void => {
    if (e.key === 'Escape' && setOpen) {
      setOpen(false);
      setTypeData(null);
    }
  }, [setOpen]);

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  const { mutate: newServiceType } = queryFn.useMutate('newServiceType',
    async () => {
      toast.warn(`${t('Services.ServiceModal.creatingNewServiceType')}`);
      try {
        const token = await AttToken();
        if (token) {
          const body = { ...token, empresa: token.userEmpresa, tipoNome: typeData?.nome, descricao: typeData?.descricao };
          await serviceType.createServiceType(body);
          setTypeData(null);
          queryClient.resetQueries({ queryKey: ['GET_SERVICES'] });
          toast.success(`${t('Services.ServiceModal.newServiceCreated')}`);
        }
      } catch (error: any) {
        console.log(error.message);
        toast.error(`${t('Services.ServiceModal.errorCreatingNewService')}`);
        return console.log(AxiosError);
      }
    });

  const { mutate } = queryFn.useMutate('editServiceType',
    async () => {
      toast.warn(`${t('Services.ServiceModal.savingChange')}`);
      try {
        const token = await AttToken();
        if (token) {
          const body = {
            ...token,
            empresa: token.userEmpresa,
            tipo: {
              nome: typeData.nome,
              tipoId: typeData?.tipoId,
              dataCriacao: typeData?.dataCriacao,
              descricao: typeData?.descricao
            }
          };
          await serviceType.editServiceType(body);
          setTypeData(null);
          toast.success(`${t('Services.servicesManagement.changeName')}`);
          queryClient.resetQueries({ queryKey: ['GET_SERVICES'] });
        }
      } catch (err: any) {
        console.log(err?.message);
      }

    });

  const close = () => {
    setTypeData(null);
    trackEventMatomo('Modal associação tipo de serviço', 'click', 'button', 'cancela');
    setOpen(false);
  };

  const submit = () => {
    trackEventMatomo('Modal associação tipo de serviço', 'click', 'button', 'salva');
    setOpen(false);
    typeData?.tipoId ? mutate('') : newServiceType('');
  };

  useEffect(() => {

  }, [typeData]);

  return (
    <Card>
      <div className={`modal ${open ? "modal is-active" : "modal"}`}>
        <div
          className="modal-background"
          onKeyDown={escape}
          onClick={() => {
            trackEventMatomo('Modal associação tipo de serviço', 'click', 'div', 'fecha modal');
            setOpen(false);
            setTypeData(null);
          }} />
        <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
          <HeaderModal
            headerTitle={typeData?.tipoId ? `${t('Services.servicesManagement.editName')}` : `${t('notifications.ticket.criarTipoServico')}`}
            close={close}
          />
          <div className="modal-card-body">
            <TextField
              size='small'
              onClick={() => trackEventMatomo('Modal associação tipo de serviço', 'click', 'textfiel', 'edita valor')}
              style={{ marginBottom: '10px' }}
              label={t('name') + ':'}
              fullWidth
              value={typeData?.nome}
              onChange={(e) => setTypeData({ ...typeData, nome: e.target.value })}
            />
            <TextField
              size='small'
              onClick={() => trackEventMatomo('Modal associação tipo de serviço', 'click', 'textfiel', 'edita valor')}
              multiline
              rows={2}
              maxRows={4}
              label={t('Services.servicesManagement.description')}
              fullWidth
              value={typeData?.descricao}
              onChange={(e) => setTypeData({ ...typeData, descricao: e.target.value })}
            />
          </div>
          <FooterModal disabled={!typeData?.nome} submit={submit} label={`${t('save')}`} />
        </div>
      </div>
    </Card>
  );
}
